export default __webpack_public_path__ + "static/media/group_2_5.aa5afad0.png";